import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './AddReviewsWhyHost.css';
import WhyHostFormBlock5 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock5/WhyHostFormBlock5'

class AddReviewsWhyHost extends React.Component {

    render() {
        return <WhyHostFormBlock5 />
    }
}

export default withStyles(s)(AddReviewsWhyHost);